import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itasec',
  templateUrl: './itasec.component.html',
  styleUrls: ['./itasec.component.css']
})
export class ItasecComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
